export default {
	name: 'workshopsSection',
	title: 'Workshops Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'workshops',
			title: 'Workshops',
			type: 'array',
			of: [
				{
					type: 'reference',
					to: [{ type: 'workshopPage' }],
				},
			],
		},
		{
			name: 'cta',
			title: 'Call to Action',
			type: 'object',
			fields: [
				{
					name: 'text',
					title: 'Button Text',
					type: 'string',
				},
				{
					name: 'link',
					title: 'Button Link',
					type: 'string',
				},
			],
		},
	],
};
